import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: ?AbsenceStatistics,
}>;

export class AbsenceStatisticFitNoteCompliance extends React.Component<Props> {
  get chartData() {
    return [
      [this.props.t("COMPLAINCE"), this.props.t("TYPE")],
      ...((this.props.data || {}).fitNoteCompliance || []).map(item => [
        item.description,
        item.value,
      ]),
    ];
  }

  render() {
    return (
      <Chart
        type="PieChart"
        title={this.props.t("FIT_NOTE_COMPLIANCE")}
        values={this.chartData}
        options={{ animation: false }}
      />
    );
  }
}

export default localize()(AbsenceStatisticFitNoteCompliance);
